var define = undefined;
var $ = require('jquery');
var vue = require('vue');
var qs = require('querystring');

var BlogIndex = vue.extend({
    template: false,
    data() {
        return {
            encodedCompanyId: '',
            notFound: false,
            articles: []
        };
    },
    computed: {
        showArticleList() {
            return this.articles.length;
        }
    },
    methods: {
        loadedArticles(data) {
            // The current path, without the file name
            // Used to make links to articles relative
            const windowPath = window.location.pathname
                .replace(/[^\/]*\.[^\/]+$/, '') // /foo/bar.html becomes /foo/
                .replace(/\/$/, ''); // remove trailing slash

            if (data.success === false) {
                return this.failedToLoadArticles();
            }

            if (data.count === 0) {
                this.notFound = true;
            }

            this.articles = $.map(data.articles, (art) => {
              if (this.encodedCompanyId) {
                art.link = `${windowPath}/articles/${art.slug}`;
              } else {
                // backwards-compatability for blogs already published without an encodedCompanyId
                art.link = `${windowPath}/articles.html?${qs.encode({
                  slug: this.slug,
                  companyId: this.encodedCompanyId,
                })}`;
              }

               return art;
            });
        },
        failedToLoadArticles() {
            console.log('failed to load articles', arguments);
            this.notFound = true;
        },
    },
    ready() {
      const ssid = this.encodedCompanyId;
      $.ajax({
          method: 'POST',
          dataType: 'json',
          data: {
              categoryIDs: this.categoryIds
          },
          url: `${this.baseUrl}/prospector/getBlogArticles/${ssid}`,
          success: this.loadedArticles.bind(this),
          error: this.failedToLoadArticles.bind(this)
      });
    }
});

module.exports = BlogIndex;



// WEBPACK FOOTER //
// ./src/js/blog/index.js